import React from 'react';
import OrgRobotStatusDashboardPage from '../../Pages/OrgRobotStatusDashboardPage';

const OrgRobotStatusDashboardContainer = () => {
  return <OrgRobotStatusDashboardPage/>;
};

export default OrgRobotStatusDashboardContainer;
